import { createFileRoute } from '@tanstack/react-router';

/**
 * Optional `appointmentId` — passed when arriving from the Director-appointment KYC submit, so the
 * review page can surface the appointment's compliance status + the "Initiate on MCA Portal" CTA.
 * Optional `legalEntityId` — the appointment's legal entity id, passed on the compliance read +
 * transitions so the backend derives the appointment's owner tenant from it (a managed entity's
 * appointment lives there, not in the caller's home tenant).
 */
export const Route = createFileRoute('/documents/$instanceId')({
  validateSearch: (
    search: Record<string, unknown>,
  ): { appointmentId?: string; legalEntityId?: string } => ({
    appointmentId: typeof search.appointmentId === 'string' ? search.appointmentId : undefined,
    legalEntityId: typeof search.legalEntityId === 'string' ? search.legalEntityId : undefined,
  }),
});
